import ptBR from "./locales/pt-BR"
import esCO from "./locales/es-CO"

export const idiomas = {
  "pt-BR": ptBR,
  "es-CO": esCO
}
